import styled from '@emotion/styled'

export default styled('div')`
  color: ${props => props.theme.color.monochrome.mediumDark};
  font-style: italic;
`
